import { apiClient } from './client';
import type { Cover, CoverConfig } from '@/types/cover';

export type CoverUpsertPayload = {
    id?: string;
    name: string;
    is_default?: boolean;
    config: CoverConfig;
};

export const coversApi = {
    list: async (): Promise<Cover[]> => {
        const response = await apiClient.get<{ data: Cover[] }>('/covers/');
        return (response as unknown as { data: Cover[] }).data;
    },

    getById: async (coverId: string): Promise<Cover> => {
        const response = await apiClient.get<{ data: Cover }>(`/covers/${coverId}`);
        return (response as unknown as { data: Cover }).data;
    },

    upsert: async (payload: CoverUpsertPayload): Promise<Cover> => {
        const response = await apiClient.post<{ data: Cover }>('/covers/', payload);
        return (response as unknown as { data: Cover }).data;
    },

    duplicate: async (coverId: string): Promise<Cover> => {
        const response = await apiClient.post<{ data: Cover }>(`/covers/${coverId}/duplicate`);
        return (response as unknown as { data: Cover }).data;
    },

    setDefault: async (coverId: string): Promise<Cover> => {
        const response = await apiClient.post<{ data: Cover }>(`/covers/${coverId}/default`);
        return (response as unknown as { data: Cover }).data;
    },

    delete: async (coverId: string): Promise<void> => {
        await apiClient.delete(`/covers/${coverId}`);
    },
};
